// store.ts
import { create } from "zustand";
import { createCartSlice } from "./slices/createCartSlice";
import { createCheckoutSlice } from "./slices/createCheckoutSlice";
import { createPricingSlice } from "./slices/createPricingSlice";
import { createProductSlice } from "./slices/createProductSlice";
import { createReferralSlice } from "./slices/createReferralSlice";
import { createToastSlice } from "./slices/createToastSlice";
export const useAppStore = create((...a) => ({
    ...createProductSlice(...a),
    ...createCartSlice(...a),
    ...createReferralSlice(...a),
    ...createCheckoutSlice(...a),
    ...createPricingSlice(...a),
    ...createToastSlice(...a),
}));
